module.exports = __webpack_public_path__ + "img/pnudlogo.02dc4b48.png";